import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import ProfileRight from "../Layouts/ProfileRight";

export default function Profile() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      navigate("/login");
    } else {
      setIsAuthenticated(true);
    }
  }, [navigate]);

  if (!isAuthenticated) return null;

  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <ProfileRight />

       </div>
      </div>

      <Feature />
      <Footer />
    </div>
  );
}
